import React, { useState } from 'react';

const SearchBar = ({ onSearch, loading }) => {
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setMobile(value);
    setError('');
  };

  const handleSearch = () => {
    if (!mobile || mobile.length !== 10) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }
    setError('');
    onSearch(mobile);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const containerStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    padding: '8px',
  };

  const flexContainerStyle = {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  };

  const inputContainerStyle = {
    flex: 1,
  };

  const inputStyle = {
    width: '100%',
    padding: '6px 8px',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    fontSize: '14px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  };

  const inputFocusStyle = {
    borderColor: '#3b82f6',
    boxShadow: '0 0 0 1px #3b82f6',
  };

  const buttonStyle = {
    padding: '6px 12px',
    backgroundColor: '#2563eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: loading ? 'not-allowed' : 'pointer',
    backgroundColor: loading ? '#9ca3af' : '#2563eb',
    opacity: loading ? 0.6 : 1,
    transition: 'background-color 0.2s',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };

  const errorStyle = {
    color: '#dc2626',
    fontSize: '12px',
    marginTop: '4px',
  };

  return (
    <div style={containerStyle}>
      <div style={flexContainerStyle}>
        <div style={inputContainerStyle}>
          <input
            type="text"
            placeholder="Enter 10-digit mobile number"
            value={mobile}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            disabled={loading}
            maxLength="10"
            style={inputStyle}
            onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
        <button
          onClick={handleSearch}
          disabled={loading}
          style={buttonStyle}
          onMouseEnter={(e) => {
            if (!loading) {
              e.target.style.backgroundColor = '#1d4ed8';
            }
          }}
          onMouseLeave={(e) => {
            if (!loading) {
              e.target.style.backgroundColor = '#2563eb';
            }
          }}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </div>
      {error && <p style={errorStyle}>{error}</p>}
    </div>
  );
};

export default SearchBar;
